import { useSyncExternalStore } from 'react';
import {
  getResolvedTheme,
  getThemePreference,
  setThemePreference,
  subscribeTheme,
  type ResolvedTheme,
  type ThemePreference,
} from '@/lib/theme';

/**
 * React binding for the theme controller. Uses useSyncExternalStore so we
 * never render stale values after the media query fires or another tab
 * writes to localStorage.
 */
export function useTheme(): {
  preference: ThemePreference;
  resolved: ResolvedTheme;
  setPreference: (next: ThemePreference) => void;
  toggle: () => void;
} {
  const preference = useSyncExternalStore(subscribeTheme, getThemePreference, getThemePreference);
  const resolved = useSyncExternalStore(subscribeTheme, getResolvedTheme, getResolvedTheme);

  return {
    preference,
    resolved,
    setPreference: setThemePreference,
    toggle: () => setThemePreference(resolved === 'dark' ? 'light' : 'dark'),
  };
}
